import { AppRoute } from '../enums';

export const notFoundRoute = {
  path: '**',
  redirectTo: `/${AppRoute.NotFound}`,
};
